import { useState, useEffect } from 'react';

interface UseMarkdownContentReturn {
  content: string;
  loading: boolean;
  error: string | null;
}

export const useMarkdownContent = (filename: string): UseMarkdownContentReturn => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // In a real application, you would fetch from an API or static files
        // For now, we'll use the markdown files we created
        const response = await fetch(`/docs/${filename}`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch ${filename}`);
        }
        
        const text = await response.text();
        setContent(text);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load content');
        console.error('Error fetching markdown content:', err);
      } finally {
        setLoading(false);
      }
    };

    if (filename) {
      fetchContent();
    }
  }, [filename]);

  return { content, loading, error };
};
